import { createSlice } from '@reduxjs/toolkit'

export interface ContactFormState {
  isAddFormVisible: boolean
}

const initialState: ContactFormState = {
  isAddFormVisible: false,
}

const contactFormSlice = createSlice({
  name: 'contactForm',
  initialState,
  reducers: {
    showAddContactForm: (state) => {
      state.isAddFormVisible = true
    },
    hideAddContactForm: (state) => {
      state.isAddFormVisible = false
    },
  },
})

export const {
  showAddContactForm,
  hideAddContactForm,
} = contactFormSlice.actions

export default contactFormSlice.reducer
